import React from "react";
import { Link, useLocation } from "react-router-dom";
import { 
    LayoutDashboard, 
    Users, 
    Play, 
    CheckCircle, 
    Flag, 
    Trophy, 
    Globe, 
    Settings, 
    UserCog, 
    Download,
    Tags
} from "lucide-react";

const NavItem = ({ to, icon: Icon, label }) => {
    const location = useLocation();
    const active = location.pathname.startsWith(to);

    return (
        <li className="relative group mb-1 overflow-hidden">
            {/* The Slanted yellow background for active state */}
            {active && (
                <div 
                    className="absolute inset-0 bg-[#FACC15] origin-left rounded-r-md opacity-10"
                    style={{ transform: "skewX(-16deg)", marginLeft: "-10px" }}
                ></div>
            )}
            {active && (
                <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-[#FACC15] rounded-r-sm"></div>
            )}
            
            <Link 
                to={to} 
                className={`flex items-center gap-3 px-4 py-2.5 rounded-md transition-colors relative z-10 ${
                    active 
                    ? "text-[#1E3A8A] font-bold" 
                    : "text-gray-600 hover:text-[#1E3A8A] hover:bg-gray-100 font-medium"
                }`}
            >
                <Icon size={20} className={active ? "text-[#1E3A8A]" : "text-gray-400 group-hover:text-[#1E3A8A]"} />
                <span className="font-inter text-sm">{label}</span>
            </Link>
        </li>
    );
};

const AdminSidebar = ({ isOpen, onClose }) => {
    return (
        <>
            {/* Mobile Overlay */}
            {isOpen && (
                <div 
                    className="fixed inset-0 bg-gray-900/50 z-40 md:hidden backdrop-blur-sm transition-opacity" 
                    onClick={onClose}
                />
            )}
            <aside className={`fixed inset-y-0 left-0 z-50 transform ${isOpen ? "translate-x-0" : "-translate-x-full"} md:relative md:translate-x-0 transition-transform duration-300 ease-in-out w-64 flex-shrink-0 bg-white border-r border-gray-200 h-full flex flex-col overflow-y-auto shadow-2xl md:shadow-none`}>
                {/* Logo / Title Area */}
                <div className="h-16 flex items-center justify-between px-6 border-b border-gray-200 shrink-0">
                    <span className="font-montserrat font-black text-[#1E3A8A] text-lg uppercase tracking-wide">
                        KMD<span className="text-[#FACC15] ml-1">Admin</span>
                    </span>
                    <button onClick={onClose} className="md:hidden text-gray-400 hover:text-gray-600 p-2 -mr-2 text-xl font-bold">
                        ✕
                    </button>
                </div>

            <nav className="flex-1 px-3 py-6 space-y-8">
                {/* Section: Všeobecná */}
                <div>
                    <h3 className="px-4 text-xs font-bold font-montserrat text-gray-400 uppercase tracking-wider mb-3">
                        Všeobecná
                    </h3>
                    <ul>
                        <NavItem to="/admin/web-settings" icon={Globe} label="Nastavenia webu" />
                        <NavItem to="/admin/user-management" icon={UserCog} label="Správa používateľov" />
                    </ul>
                </div>

                {/* Section: Maratón */}
                <div>
                    <h3 className="px-4 text-xs font-bold font-montserrat text-[#1E3A8A] uppercase tracking-wider mb-3">
                        Maratón
                    </h3>
                    <ul>
                        <NavItem to="/admin/registration-attendance" icon={Users} label="Registrácia & Prezenčka" />
                        <NavItem to="/admin/categories" icon={Tags} label="Kategórie" />
                        <NavItem to="/admin/race-management/start" icon={Play} label="Štart" />
                        <NavItem to="/admin/race-management/checkpoint" icon={CheckCircle} label="Checkpoint" />
                        <NavItem to="/admin/race-management/finish" icon={Flag} label="Cieľ" />
                        <NavItem to="/admin/results" icon={Trophy} label="Výsledky" />
                        <NavItem to="/admin/export-data" icon={Download} label="Export dát" />
                    </ul>
                </div>
            </nav>
        </aside>
        </>
    );
};

export default AdminSidebar;
